export const extractPlaceholders = (template: string): string[] => {
	const matches = template.match(/\{(\w+)\}/g) || [];
	return matches.map((match) => match.replace(/[{}]/g, ''));
};

export const replacePlaceholders = (
	template: string,
	values: Record<string, string | undefined | null>
): string => {
	return template.replace(/\{(\w+)\}/g, (_, key: string) => values[key] || '');
};
